import React, { useEffect, useRef, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

/**
 * @param {{
 *  customValue?: string,
 *  style?: React.CSSProperties,
 *  popoverProps?: React.CSSProperties,
 *  textFieldStyle?: React.CSSProperties,
 *  underlineStyle?: React.CSSProperties,
 *  floatingLabelStyle?: React.CSSProperties,
 *  inputStyle?: React.CSSProperties,
 *  menuStyle?: React.CSSProperties,
 *  disabled?: boolean,
 *  hintText?: string,
 *  hintStyle?: React.CSSProperties,
 *  floatingLabelText?: string,
 *  errorText?: string,
 *  onTextChange?: Function,
 *  onCompanySelected: Function,
 *  resetInput?: boolean,
 *  withRealCompanies?: boolean,
 *  onlyWithOwner?: boolean,
 * }} param0 
 */
export default function CompaniesAutoComplete({
    customValue = '',
    style = {},
    popoverProps = {},
    textFieldStyle = {},
    underlineStyle = {},
    floatingLabelStyle = {},
    inputStyle = {},
    menuStyle = {},
    hintStyle = {},
    disabled = false,
    hintText = '',
    floatingLabelText = '',
    errorText = undefined,
    onTextChange = () => {},
    onCompanySelected = (val) => {},
    resetInput = false,
    withRealCompanies = false,
    onlyWithOwner = false,
}) {
    const [companyValue, setCompanyValue] = useState(customValue);
    const [companies, setCompanies] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);
    const initialUpdateIgnoredRef = useRef(false);

    const debouncedSearchValue = useDebounce(companyValue, 500);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    useEffect(() => {
        setCompanyValue(customValue);
    }, [customValue]);

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        api.findCompany(debouncedSearchValue, withRealCompanies, onlyWithOwner)
            .then((response) => {
                const _companies = response.data.data.map(_company => ({
                    name: _company.name,
                    item: _company,
                }));

                setCompanies(_companies);
            })
            .catch(() => null);
    }, [debouncedSearchValue]);

    useEffect(() => {
        if (resetInput) {
            setCompanyValue('');
        }
    }, [resetInput]);

    const changeCompanyValue = (val) => {
        setCompanyValue(val);
    };

    const chooseCompany = (val) => {
        const next = val && val.name ? val.name : '';
        setCompanyValue(next);
        onCompanySelected(val);
        onTextChange(next);
    };

    return (
        <AutoComplete
            name='company'
            searchText={companyValue}
            dataSource={companies}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            hintText={hintText || 'Company name'}
            floatingLabelText={floatingLabelText}
            errorText={errorText}
            onUpdateInput={(val) => {
                if (!initialUpdateIgnoredRef.current) {
                    initialUpdateIgnoredRef.current = true;
                    if (!val) {
                        return;
                    }
                }
                changeCompanyValue(val);
                onTextChange(val);
            }}
            onNewRequest={val => chooseCompany(val)}
            filter={AutoComplete.noFilter}
            textFieldStyle={{ fontSize: '13px', ...textFieldStyle }}
            style={style}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            fullWidth={!style.width}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                ...popoverProps,
            }}
            menuStyle={{ ...menuStyle }}
            disabled={disabled}
            hintStyle={{ ...hintStyle }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/common/CompaniesAutoComplete.jsx